<template>
  <span class="body-1 text--primary">
    <span class="font-weight-bold">{{ filteredLength }}</span>
    <span> {{ $tc("pluralization.poem", filteredLength) }} </span>
    <span> {{ statTypeText }} </span>
    <span> {{ statYearText }} </span>
    <span>
      {{ $t("statistics.outOfTotalPoems", { totalCount: totalLength }) }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    filteredLength: {
      type: Number,
      required: true
    },
    totalLength: {
      type: Number,
      required: true
    },
    stat: {
      type: Object,
      required: true
    }
  },
  computed: {
    statTypeText() {
      let statTypeText;
      if (this.stat.type === "year") {
        statTypeText = ` ${this.$t("statistics.ofSelectedYears")} `;
      } else if (this.stat.type === "yearSentiment") {
        statTypeText = ` ${this.$t("statistics.ofSelectedBlocks")} `;
      } else if (this.stat.type === "sentiment") {
        statTypeText = ` ${this.$t("statistics.with")} ${this.$tc(
          "pluralization.sentiment",
          this.stat.sentiments.length
        )} ${this.stat.sentiments.join(", ")} `;
      }
      return statTypeText;
    },
    statYearText() {
      let statYearText;
      if (this.stat.years) {
        statYearText = ` ${this.$t("statistics.from")} ${this.stat.years.join(
          ", "
        )} `;
      } else if (this.stat.yearRange) {
        statYearText = ` ${this.$t("statistics.from")} ${
          this.stat.yearRange[0]
        } - ${this.stat.yearRange[1]} `;
      }
      return statYearText;
    }
  }
};
</script>
